import { render, staticRenderFns } from "./ModalHowMuchTransfer.vue?vue&type=template&id=321fffa3&scoped=true"
import script from "./ModalHowMuchTransfer.vue?vue&type=script&lang=js"
export * from "./ModalHowMuchTransfer.vue?vue&type=script&lang=js"
import style0 from "./ModalHowMuchTransfer.vue?vue&type=style&index=0&id=321fffa3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321fffa3",
  null
  
)

export default component.exports